import api from './data.services'
import { authService } from '.'

const articlesSrv = 'controls/preventions'
const articlesFilterSrv = 'controls/preventions/pages'
const articleDeleteSrv = 'controls/preventions/disabled'
const articleTemplatesSrv = 'templates/controls/preventions'

const getArticles = async () => {
  try {
    const resp: any = await api.get(articlesSrv, authService.getToken())

    return {
      status: 'Ok',
      data: (resp && resp.data && resp.data.controlPrevention ? resp.data.controlPrevention : [])
    }
  } catch (error) {
    return {
      status: 'Error',
      data: [],
      message: 'Error server al obtener artículos!'
    }
  }
}

const getArticlesSearch = async (filter: string, page: number = 1, limit: number = 10) => {
  try {
    const resp: any = await api.post(
      articlesFilterSrv,
      {
        filter,
        page,
        limit
      },
      authService.getToken()
    )

    return {
      status: 'Ok',
      data: (resp && resp.data ? resp.data : [])
    }
  } catch (error) {
    return {
      status: 'Error',
      data: [],
      message: 'Error server al obtener artículos!'
    }
  }
}

const getArticleById = async (articleId: number) => {
  try {
    const resp: any = await api.get(`${articlesSrv}/${articleId}`, authService.getToken())

    return {
      status: 'Ok',
      data: (resp && resp.data && resp.data.controlPrevention ? resp.data.controlPrevention : [])
    }
  } catch (error) {
    return {
      status: 'Error',
      data: [],
      message: 'Error server al obtener artículo!'
    }
  }
}

const getArticleTemplates = async () => {
  try {
    const resp: any = await api.get(articleTemplatesSrv, authService.getToken())

    return {
      status: 'Ok',
      data: (resp && resp.data && resp.data.controlPreventionTemplates ? resp.data.controlPreventionTemplates : [])
    }
  } catch (error) {
    return {
      status: 'Error',
      data: [],
      message: 'Error server al obtener template artículo!'
    }
  }
}

const postArticle = async (data: any) => {
  try {
    const resp: any = await api.post(articlesSrv, data, authService.getToken())

    return {
      status: 'Ok',
      data: (resp && resp.data ? resp.data : {})
    }
  } catch(error) {
    return {
      status: 'Error',
      data: {},
      message: 'Error server al guardar artículo!'
    }
  }
}

const updateArticle = async (data: any, articleId: number) => {
  try {
    const resp: any = await api.put(`${articlesSrv}/${articleId}`, data, authService.getToken())

    return {
      status: 'Ok',
      data: (resp && resp.data ? resp.data : {})
    }
  } catch(error: any) {
    return {
      status: 'Error',
      data: {},
      message: 'Error server al actualizar artículo!'
    }
  }
}

const delArticle = async (articleId: number) => {
  try {
    let resp: any = await api.del(articleDeleteSrv, articleId, authService.getToken())

    return {
      status: 'Ok',
      data: (resp && resp.data ? resp.data : [])
    }
  } catch(error) {
    return {
      status: 'Error',
      data: [],
      message: 'Error server al habilitar o deshabilitar articulo!'
    }
  }
}

export const controlPreventionService = {
  getArticles,
  getArticlesSearch,
  getArticleById,
  getArticleTemplates,
  postArticle,
  updateArticle,
  delArticle
}